import React from 'react';

const SafeTicketIcon = props => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 42 42"
    className={props.className}
  >
    <g>
      <g>
        <path
          style={{ fill: '#969696' }}
          d="M16.6,28.6v-0.3l-0.2,0.1c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.8-0.4l-1.3-1.5c0.7-1.2,0.7-2.7-0.3-3.8
          c-0.6-0.7-1.5-1.1-2.4-1.1c-0.4,0-0.9,0.1-1.3,0.3l-1.3-1.5c-0.4-0.4-0.3-1.1,0.1-1.5L20,9.4l4.4,5.1l1.1-0.4l-4.7-5.4l4.6-4
          c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.6,0.1,0.8,0.4l1.3,1.5c-0.7,1.2-0.7,2.7,0.3,3.8c0.6,0.7,1.5,1.1,2.4,1.1c0.4,0,0.9-0.1,1.3-0.3
          l1.3,1.5c0.4,0.4,0.3,1.1-0.1,1.5l-2.1,1.8l1.2,0.5l1.6-1.4c0.9-0.8,1-2.2,0.2-3.1L33,10.2l-0.5-0.6l-0.8,0.3
          c-0.3,0.1-0.5,0.2-0.8,0.2c-0.6,0-1.2-0.3-1.6-0.7c-0.6-0.7-0.7-1.7-0.2-2.4l0.5-0.7l-0.5-0.6l-1.3-1.5c-0.4-0.5-1-0.8-1.7-0.8
          c-0.5,0-1,0.2-1.4,0.5L7.8,18.4c-0.4,0.4-0.7,0.9-0.8,1.5c0,0.6,0.1,1.2,0.5,1.6L8.8,23l0.5,0.6l0.8-0.3c0.3-0.1,0.5-0.2,0.8-0.2
          c0.6,0,1.2,0.3,1.6,0.7c0.6,0.7,0.7,1.7,0.2,2.4L12.2,27l0.5,0.6l1.3,1.5c0.4,0.5,1,0.8,1.7,0.8c0.3,0,0.6-0.1,0.9-0.2
          C16.6,29.3,16.6,28.9,16.6,28.6"
        />
        <path
          style={{ fill: '#32B496' }}
          d="M34.7,18.9l-8.3-3.1c-0.1,0-0.2,0-0.3,0l-8.3,3.1c-0.2,0.1-0.3,0.2-0.3,0.4v10.2c0,1.7,0.9,3.3,2.8,5.1
          c1.4,1.2,3.1,2.4,4.9,3.5c0.3,0.2,0.6,0.4,0.8,0.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.5
          c1.7-1.1,3.5-2.3,4.9-3.5c1.9-1.7,2.8-3.4,2.8-5.1V19.3C35,19.1,34.9,18.9,34.7,18.9 M33.2,29.5c0,1.2-0.7,2.4-2.3,3.7
          c-1.3,1.1-3,2.3-4.7,3.4l-0.1,0.1l-0.1,0l0,0c-1.7-1.1-3.4-2.2-4.6-3.4c-1.5-1.4-2.3-2.6-2.3-3.7v-2.7h14V29.5z"
        />
      </g>
      <path
        style={{ fill: '#FFFFFF' }}
        d="M33.2,29.5c0,1.2-0.7,2.4-2.3,3.7c-1.3,1.1-3,2.3-4.7,3.4l-0.1,0.1l-0.1,0l0,0c-1.7-1.1-3.4-2.2-4.6-3.4
          c-1.5-1.4-2.3-2.6-2.3-3.7v-2.7h14V29.5z"
      />
    </g>
  </svg>
);

export default SafeTicketIcon;
